import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/hr/recruitment/openings')({
  component: OpeningsLayout,
})

function OpeningsLayout() {
  return <Outlet />
}
